import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react";

import { classNames } from "@helpers/css";

const AssessmentQuestionChrome = ({
  children,
  isQuestionAnswered,
  isShowingError,
  ...htmlAttributes
}: PropsWithChildren<
  {
    isShowingError?: boolean;
    isQuestionAnswered?: boolean;
    noBorder?: boolean;
  } & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>) => {
  return (
    <div
      className={classNames(
        "border rounded-lg",
        isShowingError && !isQuestionAnswered && "bg-red-50",
      )}
      {...htmlAttributes}
    >
      {children}
    </div>
  );
};

export default AssessmentQuestionChrome;
